import type { TrendGranularity } from './dashboardTrend';

export type AccountTrendGranularity = TrendGranularity | 'all';

export interface AccountTrendFocus {
  key: string;
  label: string;
  from: string;
  to: string;
  canGoPrev: boolean;
  canGoNext: boolean;
  anchor: string;
}

export type AccountTrendMetric = 'hours' | 'internal_cost' | 'billable';

export interface AccountTrendBucket {
  key: string;
  label: string;
  from: string;
  to: string;
  registered: number;
  budgetTarget: number | null;
  hasData: boolean;
}

export interface AccountTrendResponse {
  window: {
    from: string;
    to: string;
    label: string;
    canGoPrev: boolean;
    canGoNext: boolean;
    granularity: AccountTrendGranularity;
    anchor: string;
  };
  focus: AccountTrendFocus;
  meta: {
    accountId?: string;
    taskId?: string;
    companyId?: string;
    organizationId?: string;
    timezone: string;
    metric: AccountTrendMetric;
    budgetType: 'HOURS' | 'INTERNAL_COST' | 'BILLABLE' | null;
    showBudgetLine: boolean;
    currencyCode: string;
    hoursScope: 'ALL' | 'BILLABLE_ONLY';
    currencyWarning?: boolean;
  };
  buckets: AccountTrendBucket[];
  totals: {
    registered: number;
    budgetTarget: number | null;
  };
}

export function metricFromBudgetType(type: string | null | undefined): AccountTrendMetric {
  switch (type) {
    case 'INTERNAL_COST':
      return 'internal_cost';
    case 'BILLABLE':
      return 'billable';
    case 'HOURS':
    default:
      return 'hours';
  }
}

export function metricLabel(metric: AccountTrendMetric): string {
  switch (metric) {
    case 'hours':
      return 'Hours';
    case 'internal_cost':
      return 'Internal cost';
    case 'billable':
      return 'Billable';
  }
}

export const ACCOUNT_TREND_METRICS: AccountTrendMetric[] = ['hours', 'internal_cost', 'billable'];

export const ACCOUNT_TREND_GRANULARITIES: AccountTrendGranularity[] = [
  'day',
  'week',
  'month',
  'year',
  'all'
];
